import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/styles.css'
import toast, { Toaster } from 'react-hot-toast';
import AppRoutes from './component/AppRoutes';
import { useDispatch } from 'react-redux';
import { addTotalBrands, addCurrentBrand, addToken } from './redux/slices/userTypeSlice';
import useScrollToTop from './hooks/useScrollToTop';
function App() {
  useScrollToTop()
  const dispatch = useDispatch();
  const currentBrand = JSON.parse(localStorage.getItem('currentBrand'));
  const allBrand = JSON.parse(localStorage.getItem('allBrand'));
  
  const access = localStorage.getItem('access_token');
  const refresh = localStorage.getItem('refresh_token');
  
  dispatch(addTotalBrands({totalBrands: allBrand}))
  dispatch(addCurrentBrand({currentBrand: currentBrand}))
  dispatch(addToken({token: {
    access, refresh
  }}))
  return (
    <div className='bg-web'>
      <AppRoutes/>
      <Toaster toastOptions={{
          success: {
            style: {
              background: '#fff',
              borderWidth: 1,
              borderColor: "green"
            },
          },
          error: {
            style: {
              background: '#fff',
              borderWidth: 1,
              borderColor: "red"
            },
          },
        }} />
    </div>
  );
}

export default App;
